import React from "react"

import { Formik, Form, FieldArray, ErrorMessage } from "formik"
import * as yup from "yup"

import { Fieldset, Modal } from "components"
import formatMoney from "utils/formatMoney"

// import { stringifyNumber } from "utils"

const TODAY = new Date().toISOString()

const airplaneMock = {
  from: "Paris",
  to: "London",
  quantity: 1,
  price: 1000,
  deposits: [
    { dueDate: "2021-07-18", amount: 500 },
    { dueDate: "2021-07-29", amount: 500 },
  ],
}

const airplaneSchema = yup.object().shape({
  from: yup.string().required("From is reqiured"),
  to: yup.string().required("To is reqiured"),
  quantity: yup.number().required("Quantity is reqiured").min(1),
  price: yup
    .number()
    .required("Price is reqiured")
    .min(1, "Price needs to be more then 0"),
  deposits: yup.array().of(
    yup.object({
      amount: yup
        .number()
        .required("Amount is reqiured")
        .min(1, "Amount needs to be more then 0"),
      dueDate: yup.date().required("Due date is reqiured"),
    }),
  ),
})

const BookingAirplane = ({ isOpen, onClose, onSubmit }) => {
  const airplaneModel = {
    from: "",
    to: "",
    quantity: 1,
    price: 0,
    deposits: [
      { dueDate: "", amount: 0 },
      { dueDate: "", amount: 0 },
    ],

    // ...airplaneMock,
  }

  const formikProps = {
    initialValues: { ...airplaneModel },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: airplaneSchema,
    onSubmit: async (values, { setErrors }) => {
      try {
        await onSubmit(values)
        await onClose()
      } catch (error) {
        setErrors({ server: error?.graphQLErrors })
      }
    },
  }

  return (
    <Modal title="Add Air" isOpen={isOpen} onClose={onClose}>
      <div className="max-w-screen-lg mx-auto">
        <Formik {...formikProps}>
          {({ values, errors, isSubmitting }) => {
            return (
              <Form>
                <div className="w-full">
                  <div className="flex flex-wrap items-center">
                    <div className="w-3/12 px-2 py-3 ">
                      <Fieldset name={`from`} label="From" placeholder="From" />
                    </div>

                    <div className="w-3/12 px-2 py-3 ">
                      <Fieldset name={`to`} label="To" placeholder="To" />
                    </div>

                    <div className="w-2/12 px-2 py-3 ">
                      <Fieldset
                        name="round"
                        label="Round trip"
                        component="switch"
                      />
                    </div>

                    <div className="w-2/12 px-2 py-3 flex spaxe-x-1">
                      <Fieldset
                        name={`quantity`}
                        type="quantity"
                        placeholder="Quantity"
                        label="Quantity"
                      />
                    </div>

                    <div className="w-2/12 px-2 py-3 ">
                      <Fieldset name={`price`} type="price" label="Price" />
                    </div>

                    <div className="w-full px-2 py-3">
                      <label className="block text-sm font-medium text-gray-700">
                        Payment schedule:
                      </label>
                      <header className="mt-2 flex justify-between items-end px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        <div className="w-3/12">
                          <p>#</p>
                        </div>

                        <div className="w-3/12 ">
                          <p>Amount</p>
                        </div>

                        <div className="w-3/12">
                          <p>Due date</p>
                        </div>
                      </header>

                      {values.deposits?.map((_, index) => (
                        <>
                          <div
                            key={index}
                            className="flex justify-between items-end my-4 px-6"
                          >
                            <div className="w-3/12 text-base pb-3 capitalize">
                              <label>
                                {index !== values.deposits.length - 1
                                  ? `Deposit`
                                  : "Final payment"}
                              </label>
                            </div>

                            <div className="w-3/12  self-center">
                              {index !== values.deposits.length - 1 ? (
                                <Fieldset
                                  name={`deposits[${index}].amount`}
                                  type="number"
                                />
                              ) : (
                                <Fieldset
                                  listen={[`deposits[0].amount`, "price"]}
                                  name={`deposits[${index}].amount`}
                                  component="computed"
                                  mapComputedToChange={([amount, price]) => {
                                    return price - amount
                                  }}
                                  render={({ value }) => (
                                    <p>{value > 0 ? formatMoney(value) : ""}</p>
                                  )}
                                />
                              )}
                            </div>

                            <div className="w-3/12 flex justify-between items-center">
                              <Fieldset
                                name={`deposits[${index}].dueDate`}
                                type="date"
                                min={TODAY}
                                // max={endDate}
                              />
                            </div>
                          </div>
                        </>
                      ))}

                      <ErrorMessage name="payment.deposits">
                        {(msg) =>
                          typeof msg === "string" && (
                            <div className="text-sm error bg-red-200 text-red-800 p-2 mt-2">
                              {msg}
                            </div>
                          )
                        }
                      </ErrorMessage>
                    </div>
                  </div>
                </div>

                <div className="py-3">
                  {errors?.server?.map(({ code, message }) => (
                    <div role="alert">
                      <div className="bg-red-500 text-white font-bold rounded-t px-4 py-2">
                        {code}
                      </div>
                      <div className="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
                        <p>{message}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <ModalNavigation {...{ isSubmitting, onClose }} />
              </Form>
            )
          }}
        </Formik>
      </div>
    </Modal>
  )
}

export default BookingAirplane

const ModalNavigation = ({ isSubmitting, onClose }) => {
  return (
    <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
      <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
        <button
          disabled={isSubmitting}
          type="submit"
          className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50 disabled:cursor-wait"
        >
          Save
        </button>
      </span>

      <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button
          onClick={onClose}
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
          Cancel
        </button>
      </span>
    </div>
  )
}
